import { render, staticRenderFns } from "./role-manage.vue?vue&type=template&id=2f0affd2"
import script from "./role-manage.vue?vue&type=script&lang=ts"
export * from "./role-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports